import { batch } from 'react-redux';
import type { AppThunk } from '../../../store';
import type { I2FAProps } from './types';
import { loginWithCode } from '../../../apis/authApi/authAPI';
import { setUser } from '../../Login/LoginSlice';
import { setIsError } from '.';
import { convertLegacyAccountInfoToCore } from '../../../api/legacyUsers';

export const login2FACode =
  (props: I2FAProps): AppThunk =>
  async dispatch => {
    const { code, email, password } = props;
    try {
      const legacyAccountInfo = await loginWithCode({
        code,
        email,
        password,
      });

      batch(() => {
        dispatch(setUser(convertLegacyAccountInfoToCore(legacyAccountInfo)));
      });
    } catch (error) {
      console.log('error log ', error);
      batch(() => {
        dispatch(setIsError(true));
      });
    }
  };
